import baseConstants from './base/-constants'
import requestOfferConstants from './requestOffer/-constants'

export default {
  getActiveProjectSettings(state: any) {
    const allSettings = state.base.meta.generalConfig.modelDisplaySettings
    return allSettings[state.project.activeProject]
  },
  getActiveBuildingSettings(state: any) {
    const allSettings = state.base.meta.generalConfig.modelDisplaySettings
    return allSettings[state.project.activeBuilding]
  },
  cdnBase(state: any) {
    return state.base.meta.generalConfig.cdnBase
  },
  logoImage(state: any) {
    return state.base.meta.generalConfig.logo
  },
  logoImageWhite(state: any) {
    return state.base.meta.generalConfig.logoWhite
  },
  constants(library: String) {
    switch (library) {
      case 'base':
        return baseConstants
      case 'requestOffer':
        return requestOfferConstants
    }
  },
  featuresForProject: (state: any) => (projectSlug: string) => {
    return {
      ...state.base.meta.generalConfig.features.common,
      ...state.base.meta.generalConfig.features[projectSlug]
    }
  },
  getBuildingConfigData(state: any) {
    return state.base.meta.buildingConfig
  }
}
